import React from 'react'
import { Button, Icon } from '@lmc/ui-kit'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { isBrowser, isTablet } from 'react-device-detect'

interface ICarePlanReviewFooter {
  handleSubmit: () => void
  handleCancel: () => void
  isSubmitting: boolean
}

const CancelButton = styled(Button)`
  margin-right: 10px;
`

export const CarePlanReviewFooter = ({
  handleSubmit,
  handleCancel,
  isSubmitting
}: ICarePlanReviewFooter): React.ReactElement => {
  const { t } = useTranslation()
  return (
    <FooterContainer className="lmc-fixed-footer">
      <CancelButton
        data-testid="care-plan-edit-cancel"
        dataTestId="care-plan-cancel"
        onClick={handleCancel}
        variant="default"
      >
        {t('general.buttons.cancel')}
      </CancelButton>
      <Button
        data-testid="care-plan-edit-save"
        dataTestId="care-plan-save"
        isLoading={isSubmitting}
        onClick={handleSubmit}
        variant="primary"
        icon={<Icon name="CheckOutlined" />}
      >
        {t('general.buttons.save')}
      </Button>
    </FooterContainer>
  )
}

const FooterContainer = styled.div`
  border: none;
  display: flex;
  justify-content: flex-end;
  width: ${isBrowser || isTablet ? 'calc(100vw - 290px)' : '100vw'};
`

export default CarePlanReviewFooter
